import { supabase } from "@/integrations/supabase/client";

interface NotificationPayload {
  title: string;
  body: string;
  url?: string;
  type?: 'match' | 'message';
  userId: string;
}

export async function sendPushNotification(payload: NotificationPayload): Promise<boolean> {
  try {
    const { data, error } = await supabase.functions.invoke('send-push-notification', {
      body: payload,
    });

    if (error) {
      console.error('Error sending push notification:', error);
      return false;
    }

    return data?.success || false;
  } catch (error) {
    console.error('Failed to send push notification:', error);
    return false;
  }
}

export async function notifyNewMessage(receiverId: string, senderName: string): Promise<void> {
  await sendPushNotification({
    title: 'New Message',
    body: `${senderName} sent you a message`,
    url: '/chat',
    type: 'message',
    userId: receiverId,
  });
}

export async function notifyNewMatch(receiverId: string, requesterName: string): Promise<void> {
  await sendPushNotification({
    title: 'New Match Request',
    body: `${requesterName} wants to connect with you!`,
    url: '/swipe',
    type: 'match',
    userId: receiverId,
  });
}

export async function notifyChallengeJoin(creatorId: string, joinerName: string, challengeTitle: string): Promise<void> {
  await sendPushNotification({
    title: 'New Challenge Participant',
    body: `${joinerName} joined your challenge "${challengeTitle}"!`,
    url: '/explore',
    type: 'match',
    userId: creatorId,
  });
}

export async function notifyMissedCall(callerId: string, receiverName: string, reason: 'declined' | 'missed'): Promise<void> {
  const body = reason === 'declined' 
    ? `${receiverName} declined your video call`
    : `${receiverName} missed your video call`;
  
  await sendPushNotification({
    title: 'Missed Call',
    body,
    url: '/notifications',
    type: 'message',
    userId: callerId,
  });
}
